<template>
	<div id="admin">
		<header>
			<h1>
				<router-link :to="{ name: 'AdminIndex'}">Grant Manager</router-link>
			</h1>
			<button v-on:click="logOut" v-if="!isLoading && userAuth">
				<i class="fad fa-sign-out fa-fw"></i>
			</button>
		</header>
		<main>
			<div class="single-notice" v-if="isLoading && !userAuth">
				<div>
					<router-link :to="{ name: 'Login'}" class="button">
						<span>Login</span> <i class="fad fa-sign-in fa-fw"></i>
					</router-link>
				</div>
			</div>
			<div v-else>
				<nav>
					<ul v-if="!isLoading && userAuth">
						<li v-if="userAuth.role === 'admin'">
							<router-link v-bind:to="{ name: 'Applicants'}">
								<i class="fad fa-file-user fa-fw"></i> <span>Applicants</span>
							</router-link>
						</li>
						<li v-if="userAuth.role === 'admin'">
							<router-link v-bind:to="{ name: 'Admin Register'}">
								<i class="fad fa-user-plus fa-fw"></i> <span>Register</span>
							</router-link>
						</li>
						<li v-if="userAuth.role === 'admin'" class="hr">
							<router-link v-bind:to="{ name: 'Users'}">
								<i class="fad fa-users fa-fw"></i> <span>Users</span>
							</router-link>
						</li>
						<!-- <li v-if="userAuth.role === 'admin'">
							<router-link v-bind:to="{ name: 'Groups'}">
								<i class="fad fa-object-group fa-fw"></i> <span>Groups</span> <span>(Tier 1)</span>
							</router-link>
						</li> -->
						<li v-if="userAuth.role === 'admin'" class="hr">
							<router-link v-bind:to="{ name: 'Groups 2'}">
								<i class="fad fa-object-ungroup fa-fw"></i> <span>Groups</span> <span>(Tier 2)</span>
							</router-link>
						</li>
						<!-- <li v-if="userAuth.role === 'admin'">
							<router-link v-bind:to="{ name: 'Adjudication'}">
								<i class="fad fa-poll-people fa-fw"></i> <span>Adjudication</span> <span>(Tier 1)</span>
							</router-link>
						</li> -->



						<li class="hr">
							<router-link v-bind:to="{ name: 'Adjudication 2'}">
								<i class="fad fa-poll-people fa-fw"></i> <span>Adjudication</span> <span>(Tier 2)</span>
							</router-link>
						</li>




						<!-- <li v-if="userAuth.role === 'admin'" class="hr">
							<router-link v-bind:to="{ name: 'Scorecard'}">
								<i class="fad fa-poll fa-fw"></i> <span>Scorecard</span> <span>(Tier 1)</span>
							</router-link>
						</li> -->

						<li>
							<router-link v-bind:to="{ name: 'Scorecard 2'}">
								<i class="fad fa-poll fa-fw"></i> <span>Scorecard</span> <span>(Tier 2)</span>
							</router-link>
						</li>



						<!-- v-if="userAuth.role !== 'applicant' && userAuth !== 'adjudicator'" -->
						<!-- <li v-if="userAuth.role === 'admin'" class="hr hr-alt">
							<router-link v-bind:to="{ name: 'Ranking'}">
								<i class="fad fa-list-ol fa-fw"></i> <span>Ranking</span> <span>(Tier 1)</span>
							</router-link>
						</li> -->

						<li v-if="userAuth.role === 'admin'" class="hr hr-alt">
							<router-link v-bind:to="{ name: 'Ranking 2'}">
								<i class="fad fa-list-ol fa-fw"></i> <span>Ranking</span> <span>(Tier 2)</span>
							</router-link>
						</li>



						<li v-if="userAuth.role === 'applicant'" class="hr hr-alt">
							<router-link v-bind:to="'/admin/tier-2/edit/' + userAuth.applicantId" >
								<i class="fad fa-user-edit fa-fw"></i> <span>Tier 2</span>
							</router-link>
						</li>





					</ul>
				</nav>
				<div id="content" v-if="!isLoading && userAuth">
					<router-view/>
				</div>
			</div>
		</main>
		<footer>
			&copy;2021 Off The Lane Inc - v{{appVersion}}
		</footer>
	</div>
</template>
<script>
//import { projectAuth } from '../firebase/config'
import {version} from '../../package'
export default {
	data() {
		return {
			appVersion: version,
			isLoading: true
		}
	},
	computed: {
		userAuth(){
			return this.$store.getters.loggedInUser
		}
	},
	methods: {
		async loadAuth() {
			this.isLoading = true
			await this.$store.dispatch('loadAuth')
			this.isLoading = false
		},
		async logOut(){
			this.isLoading = true
			await this.$store.dispatch('logOut')
			this.$router.replace('/logout')
			this.isLoading = false
		}
	},
	async created(){
		await this.loadAuth()
	}
}
</script>
<style scoped>
:root {
	--ar-purple: #483751;
}

header {
	align-items: center;
}

header {
	backdrop-filter: blur(3px);
}

header,
footer {
	background-color: hsla(0,0%,100%,.75);
}

nav a.router-link-active {
	background-color: var(--ar-purple);
}

footer {
	border-top: 1px solid var(--ar-purple);
}

nav {
	border-right: 1px solid var(--ar-purple);
}

.hr,
header {
	border-bottom: 1px solid var(--ar-purple);
}

nav a.router-link-active {
	color: #fff;
}

nav a {
	display: block;
}

#admin,
header,
main,
footer {
	display: flex;
}

	@media (max-width:1023px){
		nav a span {
			display: none;
		}
	}

main {
	flex: auto;
}

#admin {
	flex-direction: column;
}

header {
	justify-content: space-between;
}

nav {
	height: 100%;
}

main {
	margin-top: 72px;
}

#content h1 {
	margin-bottom: .9rem;
}

nav a:not(.router-link-active):hover i {
	margin-left: 3px;
}

#content,
footer {
	margin-left: 210px;
}

	@media (max-width:1023px){
		#content,
		footer {
			margin-left: 60px;
		}
	}

button {
	min-width: 30px;
}

#admin {
	min-height: 100vh;
}

header {
	min-height: 72px;
}

nav {
	min-width: 210px;
}

	@media (max-width:1023px){
		nav {
			min-width: 60px;
		}
	}

nav a:not(.router-link-active):hover {
	opacity: .9;
}

#content {
	padding: 24px;
}

header,
footer {
	padding: 15px;
}

header button {
	padding: .9rem;
}

header,
nav {
	position: fixed;
}

nav {
	text-align: left;
}

	@media (max-width:1023px){
		nav {
			text-align: center;
		}
	}

h1 a {
	text-decoration: none;
}

header,
.single-notice,
main > div {
	width: 100%;
}

header {
	z-index: 1;
}



nav a {
	padding: 9px 15px;
}

li span + span {
	font-size: 1.2rem;
}

:deep() .rec-container {
	display: flex;
	flex-wrap: wrap;
	margin: 0 -12px;
}

	:deep() .rec {
		align-items: center;
		border: 1px solid var(--ar-purple);
		display: flex;
		justify-content: space-between;
		margin: 12px;
		padding: 9px;
		text-decoration: none;
		width: calc(33.3333% - 24px);	
	}

		:deep() .rec > div span {
			padding-right: 1ch;
		}

		:deep() .rec > div span:last-child {
			padding-right: 0;
		}

	:deep() .rec .info {
		font-size: 1.2rem;;
	}

:deep() .status {
	font-weight: bold;
	text-transform: uppercase;
}

	:deep() .status.approved {
		color: rgb(0, 110, 0);
	}

	:deep() .status.denied {
		color: #f00;
	}

	:deep() .status.tier1 {
		color: #0000FF;
	}

	:deep() .status.tier2 {
		color: #800080;
	}

	:deep() .status.tier2 {
		color: #800080;
	}

	:deep() .status.incomplete {
		color: #FFA500;
	}
</style>